/**
 * @file: 枚举数据文件
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2022-04-15 16:35:46
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-03-20 15:25:41
 * @FilePath: /console-znzs/src/utils/enum.js
 */
import {isSandbox} from './env';

// 定义dialog类型
export const DIALOG_TYPE = {
    QA: 'qa',
    ERNIE_BOT: 'ernie_bot', // 文心问答
    USER_QUESTION: 'user_question',
    SELF_HELP_TOOL: 'self_help_tool',
    CUSTOMER_EVALUATE: 'customer_evaluate', // IM会话结束之后前端推出
    PRODUCT_SELECT: 'product_select',
    TO_TS_WORDS: 'to_ts',
    TS: 'ts',
    UNKNOWN: 'unknown',
    INTERACTIVE: 'interactive', // 前端自定义的，交互达到阈值的类型
    NEGATIVE: 'negative',
};

/**
 * 消息中展示的卡片类型
 */
export const DISPLAY_TYPE = {
    HTML: 'html',
    TEXT: 'text',
    LIST: 'list',
    FILE: 'file',
    TO_TS: 'to_ts',
    WELCOME: 'welcome',
    KNOWLEDGE: 'knowledge',
    EVALUATION: 'evaluation', // 会话列表中完成的会话和待评价的会话自动推出的卡片类型
    MANUAL_TO_TS: 'manual_to_ts', // 用户主动触发转人工
    ERNIE_LOADING: 'ernie_loading', // 文心消息loading
    CREATE_TICKET: 'create_ticket',
    /**
     * @deprecated
    */
    SELECT_PRODUCT: 'select_product', // 只选择产品的弹窗,比如退款、后端不会再返回了
    REFUND_TOOL: 'self_help_refund_tool', // 自助退款工具
    TO_SUBMIT_TICKET: 'to_submit_ticket',
    SMS_TOOL: 'self_help_sms_audited_tool', // 自助SMS审核工具
    SUCCESS_CREATE_TICKET: 'success_create_ticket',
    CONFIG_CHANGE_TOOL: 'self_help_config_change_tool', // 自助升降配工具

    ERNIE_BOT: DIALOG_TYPE.ERNIE_BOT,
    SELF_HELP_TOOL: DIALOG_TYPE.SELF_HELP_TOOL,
    PRODUCT_SELECT: DIALOG_TYPE.PRODUCT_SELECT,
    CUSTOMER_EVALUATE: DIALOG_TYPE.CUSTOMER_EVALUATE,
};
// 显示评价的dialog类型
export const evaluateDialogtypeList = [
    DIALOG_TYPE.QA,
    DIALOG_TYPE.SELF_HELP_TOOL,
];

// 用户侧人机、IM消息
export const CHANNEL = 'bce_website';

/**
 * 只随环境变化的常量
 */
export const constant = {
    [isSandbox]: {
        // 登录链接
        loginLink: 'https://login.bcetest.baidu.com/?redirect=',
        // 售后域名
        console: 'https://qasandbox.bcetest.baidu.com',
        // 售前留言
        contactUsLink: 'https://cloudtest.baidu.com/survey/connect-us.html',
        // 游客模式验证登录
        veryLogin: 'https://bcetest.baidu.com',
        ticketDomain: 'https://ticket.bcetest.baidu.com',
        // 提交工单
        createTicketLink: 'https://ticket.bcetest.baidu.com/#/ticket/create',
        // 工单详情
        ticketDetail: 'https://ticket.bcetest.baidu.com/#/ticket/detail?ticketId=',
        // 工单新域名
        ticketDomainNew: 'https://qasandbox.bcetest.baidu.com/ticket/',
        createTicketLinkNew: 'https://qasandbox.bcetest.baidu.com/support/#/ticket/#/ticket/create',
        ticketDetailNew: '/ticket/#/ticket/detail?ticketId=',
        // 服务与支持中，工单详情
        supportTicketDetail: 'https://qasandbox.bcetest.baidu.com/support#/ticket/#/ticket/detail?ticketId=',
        // 官网文档
        officalDoc: [
            'https://cloudtest.baidu.com/doc/',
            'https://cloud.baidu.com/doc/',
        ],
        // 退订管理
        refundManage: 'https://qasandbox.bcetest.baidu.com/billing/#/refund/confirm',
        // BCC改配
        changeConfig: 'https://qasandbox.bcetest.baidu.com/bcc/#/bcc/instance/upgrade_config',
        // 签名管理
        signatureLink: 'https://qasandbox.bcetest.baidu.com/smsv3/#/smsv3/gnsignature/list',
        // 模版管理
        templateLink: 'https://qasandbox.bcetest.baidu.com/smsv3/#/smsv3/gntemplate/list',
        // 工具箱
        toolHost: 'https://qasandbox.bcetest.baidu.com/tools',
    },
    [!isSandbox]: {
        loginLink: 'https://login.bce.baidu.com/?redirect=',
        console: 'https://console.bce.baidu.com',
        contactUsLink: 'https://cloud.baidu.com/survey/connect-us.html',
        veryLogin: 'https://bce.baidu.com',
        ticketDomain: 'https://ticket.bce.baidu.com',
        createTicketLink: 'https://ticket.bce.baidu.com/#/ticket/create',
        ticketDetail: 'https://ticket.bce.baidu.com/#/ticket/detail?ticketId=',
        ticketDomainNew: 'https://console.bce.baidu.com/ticket/',
        createTicketLinkNew: 'https://console.bce.baidu.com/support/#/ticket/#/ticket/create',
        ticketDetailNew: '/ticket/#/ticket/detail?ticketId=',
        supportTicketDetail: 'https://console.bce.baidu.com/support#/ticket/#/ticket/detail?ticketId=',
        officalDoc: [
            'https://cloud.baidu.com/doc/',
        ],
        refundManage: 'https://console.bce.baidu.com/billing/#/refund/confirm',
        changeConfig: 'https://console.bce.baidu.com/bcc/#/bcc/instance/upgrade_config',
        signatureLink: 'https://console.bce.baidu.com/smsv3/#/smsv3/gnsignature/list',
        templateLink: 'https://console.bce.baidu.com/smsv3/#/smsv3/gntemplate/list',
        toolHost: 'https://console.bce.baidu.com/tools',
    },
};

/**
 * 用户提问的trigger
 */
export const QUESTION_TRIGGER = {
    INPUT: 'input', // 输入框提交
    GUIDE: 'guide', // 推荐知识
    RELATION: 'relation', // 知识下面的相关问题
    GREETING: 'greeting', // 欢迎语中的猜你想了解/创建工单卡片中推荐问题
    /**
     * @deprecated 输入框上方的推荐问题，已经不存在了
     */
    NAVIGATION: 'navigation', // 输入框上方的导航推荐
    ASSOCIATION: 'association', // 联想推荐
    CREATE_TICKET: 'create_ticket', // 创建工单发的空白消息
    TICKET_SUM_REC: 'ticket_sum_rec', // 创建工单描述的联想
    TICKET_SUM_QUERY_RESULT: 'ticket_sum_query_result', // 创建工单描述的文心联想
    TICKET_AUTO_ASK: 'ticket_auto_ask', // 自动问
    SUCCESS_CREATE_TICKET: 'success_create_ticket', // 成功创建工单的空白消息
};

// 用于跟踪数据的场景
export const TRACE_SCENE = {
    ZNZS: 'znzs',
    CONFIRM_TICKET: 'confirmTicket',
    TICKET: 'ticket',
};
